// Jewelry module — French strings (sales, reports, trade-ins, certificates, spot rates)
// Navigation labels (Point of Sale, Sales History, Gemstone Certificates, Metal Spot Rates)
// live in jewelryDictionary.nav.ts.
export const frSales: Record<string, string> = {
  // Shared
  'Accept': 'Accepter',
  'Add Certificate': 'Ajouter un certificat',
  'All': 'Tous',
  'Cancel': 'Annuler',
  'Cannot be negative': 'Ne peut pas être négatif',
  'Clear': 'Vider',
  'Close': 'Fermer',
  'Customer': 'Client',
  'Customer name': 'Nom du client',
  'Date': 'Date',
  'Delete': 'Supprimer',
  'Export CSV': 'Exporter en CSV',
  'Items': 'Articles',
  'Jewelry Store': 'Bijouterie',
  'Metal': 'Métal',
  'Must be greater than 0': 'Doit être supérieur à 0',
  'Notes': 'Notes',
  'Phone': 'Téléphone',
  'Piece': 'Pièce',
  'Pieces': 'Pièces',
  'pieces': 'pièces',
  'Refresh': 'Actualiser',
  'Remove': 'Retirer',
  'Required': 'Obligatoire',
  'Retry': 'Réessayer',
  'Status': 'Statut',
  'Total': 'Total',
  'Updated': 'Mis à jour',
  'View': 'Voir',
  'Weight': 'Poids',
  'Weight (g)': 'Poids (g)',
  'Gold': 'Or',
  'Silver': 'Argent',
  'Platinum': 'Platine',
  'Cash': 'Espèces',
  'Mobile Money': 'Mobile Money',
  'Card / POS': 'Carte / TPE',
  'Bank Transfer': 'Virement bancaire',

  // POS
  'Amount due': 'Montant dû',
  'Amount paid': 'Montant payé',
  'Amount paid is less than the amount due': 'Le montant payé est inférieur au montant dû',
  'Apply an accepted trade-in': 'Appliquer une reprise acceptée',
  'Change': 'Monnaie à rendre',
  'Complete Sale': 'Finaliser la vente',
  'Could not load the inventory': 'Impossible de charger l\'inventaire',
  'Current Sale': 'Vente en cours',
  'Discount': 'Remise',
  'Failed to complete the sale': 'Échec de la vente',
  'Failed to load jewelry inventory': 'Échec du chargement de l\'inventaire',
  'Line total': 'Total de la ligne',
  'No pieces available for sale': 'Aucune pièce disponible à la vente',
  'Payment method': 'Mode de paiement',
  'Price': 'Prix',
  'Print Receipt': 'Imprimer le reçu',
  'Sale completed': 'Vente finalisée',
  'Search by title, serial number or location': 'Rechercher par titre, numéro de série ou emplacement',
  'Select a piece to start a sale': 'Sélectionnez une pièce pour démarrer une vente',
  'Sell vault pieces, apply trade-ins and print receipts': 'Vendez des pièces du coffre-fort, appliquez des reprises et imprimez des reçus',
  'Subtotal': 'Sous-total',
  'Trade-in credit': 'Crédit de reprise',

  // Receipt
  'Amount received': 'Montant reçu',
  'Balance due': 'Solde dû',
  'Jewelry Sales Receipt': 'Reçu de vente de bijouterie',
  'Serial': 'N° de série',
  'Thank you for your purchase!': 'Merci pour votre achat !',
  'Transaction #': 'Transaction n°',
  'Walk-in Customer': 'Client de passage',

  // Sales history
  'Could not load sales history': 'Impossible de charger l\'historique des ventes',
  'Completed jewelry sales and receipts': 'Ventes de bijouterie finalisées et reçus',
  'Failed to load sales history': 'Échec du chargement de l\'historique des ventes',
  'No sales found': 'Aucune vente trouvée',
  'Payment': 'Paiement',
  'All payment methods': 'Tous les modes de paiement',
  'Receipt': 'Reçu',
  'Sales': 'Ventes',
  'sales': 'ventes',
  'Search transaction, customer or piece': 'Rechercher une transaction, un client ou une pièce',
  'Transaction': 'Transaction',
  'Trade-in Credit': 'Crédit de reprise',
  'Trade-in Credit Applied': 'Crédit de reprise appliqué',

  // Reports
  'Average Sale': 'Vente moyenne',
  'Could not load the report': 'Impossible de charger le rapport',
  'Failed to load jewelry report': 'Échec du chargement du rapport',
  'Inventory Valuation': 'Valorisation de l\'inventaire',
  'Jewelry Reports': 'Rapports de bijouterie',
  'Margin over melt value': 'Marge sur la valeur de fonte',
  'Metal value': 'Valeur du métal',
  'No pieces in stock': 'Aucune pièce en stock',
  'No sales in this period': 'Aucune vente sur cette période',
  'Payment Methods': 'Modes de paiement',
  'Retail value': 'Valeur de vente',
  'Revenue': 'Chiffre d\'affaires',
  'Sales in Period': 'Ventes de la période',
  'Sales performance and inventory valuation': 'Performance des ventes et valorisation de l\'inventaire',
  'Vault Retail Value': 'Valeur de vente du coffre-fort',

  // Spot rates
  'Could not load spot rates': 'Impossible de charger les cours',
  'Current rate': 'Cours actuel',
  'Discard changes': 'Annuler les modifications',
  'Every rate must be greater than 0': 'Chaque cours doit être supérieur à 0',
  'Failed to load spot rates': 'Échec du chargement des cours',
  'Failed to reprice inventory': 'Échec de la revalorisation de l\'inventaire',
  'Failed to update spot rates': 'Échec de la mise à jour des cours',
  'New rate': 'Nouveau cours',
  'Per-gram rates used for pricing, valuation and trade-in appraisals': 'Cours au gramme utilisés pour la tarification, la valorisation et l\'estimation des reprises',
  'piece(s) repriced at current spot rates': 'pièce(s) revalorisée(s) aux cours actuels',
  'Precious Metal Rates': 'Cours des métaux précieux',
  'Purity': 'Titre',
  'Recalculate the selling price of every unsold piece from the current spot rate, weight and crafting charge. Manual prices on unsold pieces will be overwritten.':
    'Recalcule le prix de vente de chaque pièce invendue à partir du cours actuel, du poids et des frais de façon. Les prix manuels des pièces invendues seront écrasés.',
  'Reprice': 'Revaloriser',
  'Reprice all unsold pieces': 'Revaloriser toutes les pièces invendues',
  'Reprice all unsold pieces?': 'Revaloriser toutes les pièces invendues ?',
  'Reprice inventory': 'Revaloriser l\'inventaire',
  'Save rates': 'Enregistrer les cours',
  'Save your rate changes before repricing.': 'Enregistrez vos modifications de cours avant de revaloriser.',
  'Spot rates updated': 'Cours mis à jour',
  'This overwrites their current selling prices.': 'Cela écrase leurs prix de vente actuels.',

  // Trade-ins
  'Accepted': 'Acceptée',
  'Accepted (ready to apply)': 'Acceptées (prêtes à appliquer)',
  'Accepted and applied': 'Acceptées et appliquées',
  'All statuses': 'Tous les statuts',
  'Applied to sale': 'Appliquée à une vente',
  'Appraise customer scrap and apply accepted payouts as credit at the POS': 'Estimez l\'or de reprise des clients et appliquez les paiements acceptés en crédit à la caisse',
  'Appraised': 'Estimée',
  'Awaiting decision': 'En attente de décision',
  'Could not load trade-ins': 'Impossible de charger les reprises',
  'Delete this appraisal?': 'Supprimer cette estimation ?',
  'Failed to delete trade-in': 'Échec de la suppression de la reprise',
  'Failed to load trade-ins': 'Échec du chargement des reprises',
  'Failed to log trade-in': 'Échec de l\'enregistrement de la reprise',
  'Failed to update trade-in': 'Échec de la mise à jour de la reprise',
  'Melt value at spot': 'Valeur de fonte au cours',
  'New Appraisal': 'Nouvelle estimation',
  'New Trade-in Appraisal': 'Nouvelle estimation de reprise',
  'No trade-ins found': 'Aucune reprise trouvée',
  'Offered payout': 'Paiement proposé',
  'Reject': 'Refuser',
  'Rejected': 'Refusée',
  'Reopen': 'Rouvrir',
  'Save appraisal': 'Enregistrer l\'estimation',
  'Scrap acquired': 'Or de reprise acquis',
  'Tested purity': 'Titre testé',
  'Total payout': 'Total des paiements',
  'Trade-in appraisal logged': 'Estimation de reprise enregistrée',
  'Trade-in deleted': 'Reprise supprimée',
  'Trade-in updated': 'Reprise mise à jour',
  'Trade-ins': 'Reprises',

  // Certificates
  'Added': 'Ajouté le',
  'Authority': 'Organisme',
  'Carat': 'Carat',
  'Carat weight': 'Poids en carats',
  'Certificate': 'Certificat',
  'Certificate added': 'Certificat ajouté',
  'Certificate deleted': 'Certificat supprimé',
  'Certificate number': 'Numéro de certificat',
  'certificates': 'certificats',
  'Clarity': 'Pureté',
  'Color': 'Couleur',
  'Could not load certificates': 'Impossible de charger les certificats',
  'Cut': 'Taille',
  'Delete this certificate?': 'Supprimer ce certificat ?',
  'Enter a valid http(s) URL': 'Saisissez une URL http(s) valide',
  'Failed to add certificate': 'Échec de l\'ajout du certificat',
  'Failed to delete certificate': 'Échec de la suppression du certificat',
  'Failed to load certificates': 'Échec du chargement des certificats',
  'Add Gemstone Certificate': 'Ajouter un certificat de pierre précieuse',
  'Grading reports attached to vault pieces': 'Rapports de gradation rattachés aux pièces du coffre-fort',
  'No certificates found': 'Aucun certificat trouvé',
  'Report link (optional)': 'Lien du rapport (facultatif)',
  'Save certificate': 'Enregistrer le certificat',
  'Search certificate number, authority or piece': 'Rechercher un numéro de certificat, un organisme ou une pièce',
  'Select a piece': 'Sélectionnez une pièce',
};
